import React, { useState } from "react";
import { useIssueAction } from "../trips/tripIssue";

interface IssueActionsBarProps {
  openIssueDetails: (e: React.MouseEvent<HTMLAnchorElement>, size: string) => void;
  openIssueAssign: (e: React.MouseEvent<HTMLAnchorElement>, size: string) => void;
}

const IssueActionsBar: React.FC<IssueActionsBarProps> = ({ openIssueDetails, openIssueAssign }) => {
  const {
    isIssueClosed,
    isIssueAssisting,
    assistIssue,
    openIssueComment,
    openIssueDefer,
    awayContactPointsAvailable,
    eatEvent,
    isIssueOpen,
    openIssue,
    awayContactPointsEmails
  } = useIssueAction();

  const [hoverState, setHoverState] = useState({
    assign: false,
    assist: false,
    comment: false,
    defer: false,
    details: false,
    message: false,
    reopen: false,
  });

  const handleMouseEnter = (key: keyof typeof hoverState) => {
    setHoverState((prev) => ({ ...prev, [key]: true }));
  };

  const handleMouseLeave = (key: keyof typeof hoverState) => {
    setHoverState((prev) => ({ ...prev, [key]: false }));
  };

  const renderActionIcon = (
    title: string,
    hoverKey: keyof typeof hoverState,
    onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void,
    normalIconClass: string,
    selectedIconClass: string,
    disabledIconClass: string,
    isDisabled: boolean
  ) => (
    <a
      title={title}
      onMouseEnter={() => handleMouseEnter(hoverKey)}
      onMouseLeave={() => handleMouseLeave(hoverKey)}
      onClick={isDisabled ? eatEvent : onClick}
    >
      <i
        className={`hidden-xs sprites ${
          isDisabled
            ? disabledIconClass
            : hoverState[hoverKey]
            ? selectedIconClass
            : normalIconClass
        }`}
      ></i>
      <i
        className={`visible-xs sprites ${
          isDisabled
            ? disabledIconClass
            : hoverState[hoverKey]
            ? selectedIconClass.replace("24", "16")
            : normalIconClass.replace("24", "16")
        }`}
      ></i>
    </a>
  );

  return (
    <div className="actions">
      {renderActionIcon(
        "Assign",
        "assign",
        (e) => openIssueAssign(e, "sm"),
        "sprite-assign-normal-24",
        "sprite-assign-selected-24",
        "sprite-assign-disabled-24",
        isIssueClosed()
      )}
      {renderActionIcon(
        "Assist",
        "assist",
        assistIssue,
        "sprite-assist-normal-24",
        "sprite-assist-selected-24",
        "sprite-assist-disabled-24",
        isIssueAssisting() || isIssueClosed()
      )}
      {renderActionIcon(
        "Comment",
        "comment",
        openIssueComment,
        "sprite-comment-normal-24",
        "sprite-comment-selected-24",
        "sprite-comment-disabled-24",
        isIssueClosed()
      )}
      {renderActionIcon(
        "Defer",
        "defer",
        openIssueDefer,
        "sprite-defer-normal-24",
        "sprite-defer-selected-24",
        "sprite-defer-disabled-24",
        isIssueClosed()
      )}
      {renderActionIcon(
        "Details",
        "details",
        (e) => openIssueDetails(e, "lg"),
        "sprite-details-normal-24",
        "sprite-details-selected-24",
        "sprite-details-disabled-24",
        false
      )}
      {renderActionIcon(
        "Send Message",
        "message",
        (e) => {
          e.preventDefault();
          window.open(`mailto:${awayContactPointsEmails()}`, "_blank");
        },
        "sprite-message-normal-24",
        "sprite-message-selected-24",
        "sprite-message-disabled-24",
        !awayContactPointsAvailable()
      )}
      {renderActionIcon(
        "Re-Open",
        "reopen",
        openIssue,
        "sprite-reopen-normal-24",
        "sprite-reopen-selected-24",
        "sprite-reopen-disabled-24",
        isIssueOpen()
      )}
    </div>
  );
};

export default IssueActionsBar;